import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../App/Hooks/reduxHooks'
import { setUserSettings } from '../settings/userSettings'
import { setAmountOfCalendarDays as setDays } from '../store/calendarSlice'

import {
  CalendarSettingsPanelButtonsWrapper,
  DaySettingsButton,
  DaySettingsButtonText,
} from './style'

interface IButtonData {
  numberOfDays: 1 | 3 | 7
  text: 'DAY' | 'DAYS' | 'WEEK'
}

export const AmountOfCalendarDaysButton = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const buttonObjectArray: IButtonData[] = [
    { numberOfDays: 1, text: t('DAY') },
    { numberOfDays: 3, text: t('DAYS') },
    { numberOfDays: 7, text: t('WEEK') },
  ]

  const setAmountOfCalendarDays = (numberOfDays: 1 | 3 | 7) => {
    setUserSettings({ amountOfCalendarDays: numberOfDays })
    dispatch(setDays({ amountOfCalendarDays: numberOfDays }))
  }

  return (
    <CalendarSettingsPanelButtonsWrapper>
      {buttonObjectArray.map(buttonObject => (
        <DaySettingsButton
          key={`dayButton${buttonObject.numberOfDays}`}
          onClick={() => setAmountOfCalendarDays(buttonObject.numberOfDays)}>
          <DaySettingsButtonText>
            {`${
              buttonObject.numberOfDays !== 7 ? buttonObject.numberOfDays : ''
            } ${buttonObject.text}`}
          </DaySettingsButtonText>
        </DaySettingsButton>
      ))}
    </CalendarSettingsPanelButtonsWrapper>
  )
}
